var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgXmlFile = function SvgXmlFile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 115,
    viewBox: "0 0 114 115",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 14.8667C26 13.2098 27.3431 11.8667 29 11.8667H66.5858L94 39.2809V100.867C94 102.524 92.6569 103.867 91 103.867H29C27.3431 103.867 26 102.524 26 100.867V14.8667Z",
    fill: "white",
    stroke: "#E1E1E1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 10.8667L95 38.8667H71C68.7909 38.8667 67 37.0758 67 34.8667V10.8667Z",
    fill: "#E1E1E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5308_225004)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "box",
    x: 15,
    y: 57.8667,
    width: 63,
    height: 33,
    rx: 4,
    fill: "currentColor",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2401 68.7303L34.5866 72.6962H34.6776L37.0355 68.7303H39.8139L36.2628 74.5485L39.8935 80.3667H37.0639L34.6776 76.3951H34.5866L32.2003 80.3667H29.3821L33.0241 74.5485L29.4503 68.7303H32.2401ZM41.3707 68.7303H44.4048L47.6094 76.5485H47.7457L50.9503 68.7303H53.9844V80.3667H51.598V72.7928H51.5014L48.4901 80.3099H46.8651L43.8537 72.7644H43.7571V80.3667H41.3707V68.7303ZM56.0114 80.3667V68.7303H58.4716V78.3383H63.4602V80.3667H56.0114Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5308_225004",
    x: 11,
    y: 56.8667,
    width: 71,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.701961 0 0 0 0 0.737255 0 0 0 0 0.752941 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5308_225004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5308_225004",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgXmlFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "xml-file.9ff649ca3ae3d13942cd7cec39015ae4.svg";